export default __webpack_public_path__ + "static/media/a.9d050c50.png";